module.exports = __webpack_public_path__ + "img/mask.2ae06b3.png";